export default __webpack_public_path__ + "ab4e4713319ca89a3e79b57bc2b88d62.png";